/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const CreateJiraIssueContainer = styled.div({
  maxWidth: `${gridSize() * 66}px`,
  margin: `${gridSize() * 3}px`,
  marginBottom: `${gridSize() * 2}px`,
});

export const CustomPopupContainer = styled.div({
  width: `${gridSize() * 72}px`,
  maxWidth: '100%',
  boxShadow: token('elevation.shadow.overlay'),
  backgroundColor: token('elevation.surface.overlay'),
});
